import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Marcus T.",
    location: "Mt. Lebanon, PA",
    service: "Termite Treatment",
    quote:
      "Found termites in my basement beams. These guys came out same week, did a real inspection — showed me exactly what was happening. Year later, no signs. Worth every dollar.",
  },
  {
    name: "Yolanda R.",
    location: "Squirrel Hill, PA",
    service: "Bed Bug Eradication",
    quote:
      "Discreet, professional, and they spoke Spanish with my mom which was huge. Went from sleeping on the couch to back in my bed in under two weeks.",
  },
  {
    name: "Dave K.",
    location: "South Side, PA",
    service: "Quarterly Plan",
    quote:
      "Been on the quarterly plan for two years. Haven't seen a spider, ant, or mouse since they started. The tech actually knows my house. That matters.",
  },
  {
    name: "Pittsburgh Public Schools",
    location: "Allegheny County",
    service: "Parks & Schools Program",
    quote:
      "Documentation is thorough, scheduling is reliable, and the protocols are child-safe. They're the only outfit we trust on our playgrounds.",
  },
  {
    name: "Jenny & Paul S.",
    location: "Brookline, PA",
    service: "Wildlife Removal",
    quote:
      "Family of raccoons in the attic. Humanely trapped, sealed the entry points, even fixed the soffit. No upsell games — just got it done.",
  },
  {
    name: "Carlos M.",
    location: "Beechview, PA",
    service: "Mosquito Control",
    quote:
      "We actually use our backyard now. Two kids, a dog, and not a single bite all summer. Treatment didn't bother any of us. Highly recommend.",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="border-b border-zinc-900 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 mb-14 items-end">
          <div className="md:col-span-7">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D9480F] font-bold mb-4">
              [ 04 ] — Pittsburgh Talks Back
            </p>
            <h2 className="font-display uppercase font-semibold leading-[0.9] tracking-tighter text-4xl md:text-6xl">
              Real reviews. <br />
              <span className="text-[#0B2B40]">Real neighbors.</span>
            </h2>
          </div>
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 text-[#F59E0B] fill-[#F59E0B]" />
              ))}
            </div>
            <p className="font-mono text-sm uppercase tracking-[0.15em] text-zinc-700">
              5.0 / 5 on Google · Pittsburgh homeowners agree
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <article
              key={i}
              className="bg-[#F4F4F5] border-2 border-zinc-900 p-7 flex flex-col hard-shadow-sm hover:translate-x-[-2px] hover:translate-y-[-2px] hover:shadow-[6px_6px_0_0_#0B2B40] transition-transform"
            >
              <Quote className="w-8 h-8 text-[#D9480F] mb-4" strokeWidth={2.5} />
              <p className="text-zinc-800 leading-relaxed text-base mb-6 flex-1">
                "{t.quote}"
              </p>
              <div className="border-t border-zinc-300 pt-4 flex items-center justify-between">
                <div>
                  <div className="font-display uppercase text-sm font-semibold tracking-tight">
                    {t.name}
                  </div>
                  <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500">
                    {t.location}
                  </div>
                </div>
                <div className="flex items-center gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-3.5 h-3.5 text-[#F59E0B] fill-[#F59E0B]" />
                  ))}
                </div>
              </div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#D9480F] mt-3 font-bold">
                · {t.service}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
